import React from 'react';

import PropTypes from 'prop-types';

import { ProgressBar } from 'apps/auth/components/common/components/ProgressBar/ProgressBar';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Text } from 'apps/auth/components/common/Text/Text';
import { toLowerCase } from 'apps/auth/helpers/utils';

export const LimitBlock = (props) => {
    const { isDisabledLimit = false, isExhaustedLimit } = props;
    const getLimitColor = () => {
        let color = 'primary';
        if (isDisabledLimit) {
            color = 'lightGray';
        } else if (isExhaustedLimit) {
            color = 'error';
        }
        return color;
    };

    return (
        <>
            {props.title && (
                <Text variant="div" indent="adaptive-16-24">
                    {props.title}
                </Text>
            )}
            <Row indent="adaptive-16-24">
                {props.isLimitError && <Text variant="div">{props.limitErrorText}</Text>}
                {!props.isLimitError && (
                    <ProgressBar isDisabledLimit={isDisabledLimit} isExhaustedLimit={isExhaustedLimit} progressWidth={props.progressWidth} />
                )}
            </Row>
            <Row flex align="center" justify="between">
                <Text color={getLimitColor()} size="header">
                    {props.spendSum + ' '}
                    <Text color={getLimitColor()} size="header" smallCaps>
                        {toLowerCase(props.currency)}
                    </Text>
                </Text>
                <Text color="secondary" textAlign="right">
                    {props.leftSum + ' '}
                    <Text color="secondary" smallCaps>
                        {toLowerCase(props.currency)}
                    </Text>
                </Text>
            </Row>
            <Row flex justify="between">
                <Text color={getLimitColor()} size="secondary">
                    {props.spendText}
                </Text>
                <Text color="secondary" size="secondary" textAlign="right">
                    {props.leftText}
                </Text>
            </Row>
        </>
    );
};

LimitBlock.propTypes = {
    title: PropTypes.string,
    isExhaustedLimit: PropTypes.bool,
    isDisabledLimit: PropTypes.bool,
    spendSum: PropTypes.string,
    leftSum: PropTypes.string,
    currency: PropTypes.string,
    spendText: PropTypes.string,
    leftText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    progressWidth: PropTypes.number,
    isLimitError: PropTypes.bool,
    limitErrorText: PropTypes.string,
};
